/** hack to fix typescript/babel transpilation issue
 *
 * https://github.com/Microsoft/TypeScript/issues/22585
 * https://github.com/Microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work  */
export function setCustomErrorType(thisObj, ErrorClass) {
    Object.setPrototypeOf(thisObj, ErrorClass.prototype);
}
//# sourceMappingURL=custom-error-utils.js.map